module.exports = __webpack_public_path__ + "static/img/防护网开关识别.c9d6079a.png";